import { render, staticRenderFns } from "./retrievepwd.vue?vue&type=template&id=773dbcc5&scoped=true"
import script from "./retrievepwd.vue?vue&type=script&lang=js"
export * from "./retrievepwd.vue?vue&type=script&lang=js"
import style0 from "./retrievepwd.vue?vue&type=style&index=0&id=773dbcc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773dbcc5",
  null
  
)

export default component.exports